export const MOBILE_BREAKPOINT = 767;
export const TABLET_BREAKPOINT = 991;
export const URGENCY_DESTINATION_MESSAGE_TYPE = 'ICON_TITLE_TEXT_V1';

export const LAZY_LOAD_OFFSET = {
    DEFAULT: 100,
    MOBILE: 66
};
